import axios from 'axios';

const getHeroImages = () => {
	return axios.get('https://backend.planmyleisure.com/blog/hero-image');
};

export default getHeroImages;
